define.alias("shared/utils/hex-to-rgb", "settings/utils/hex-to-rgb");